
































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import VueRouter from "vue-router";
import Sling from "@/classes/Sling";
import SlingCanvas from "@/components/SlingCanvas.vue";
import axios from "axios";
import { AxiosRequestConfig } from "axios";

@Component({
    components: {
        SlingCanvas,
    },
})
export default class Home extends Vue {
    sling: Sling | null = null;

    mounted() {
        this.sling = new Sling();

        // ダミー
        /*
        this.sling.targetWeightCode = "8";
        this.sling.targetNumberCode = "4";
        this.sling.wireCode = "1";
        this.sling.wireLengthCode = "11";
        this.sling.ringCode = "M06";
        this.sling.hookCode = "M13";
         */
    }

    get linkDon() {
        return Sling.linkDon;
    }

    get weightOptions() {
        if (!this.sling) return [];

        const options = [];

        for (const code in this.sling.targetWeights) {
            const value = this.sling.targetWeights[code];

            options.push({
                text: value,
                value: code,
            });
        }

        return options;
    }

    get numberOptions() {
        if (!this.sling) return [];

        const options = [];

        for (const code in this.sling.targetNumbers) {
            const value = this.sling.targetNumbers[code];

            options.push({
                text: value,
                value: code,
            });
        }

        return options;
    }

    get wireOptions() {
        if (!this.sling) return [];

        const options = [];

        for (const code in this.sling.wires) {
            const value = this.sling.wires[code];

            options.push({
                text: value,
                value: code,
            });
        }

        return options;
    }

    get lengthOptions() {
        if (!this.sling) return [];

        const options = [];

        for (const code in this.sling.wireLengths) {
            const value = this.sling.wireLengths[code];

            options.push({
                text: value,
                value: code,
            });
        }

        return options;
    }

    get ringOptions() {
        if (!this.sling) return [];

        const sling = this.sling;

        return this.sling.ringCodes.map((code) => {
            if (code in sling.ringSpecs) {
                return {
                    text: sling.ringSpecs[code]["name"],
                    value: code,
                };
            }
        });
    }

    get hookOptions() {
        if (!this.sling) return [];

        const sling = this.sling;

        return this.sling.hookCodes.map((code) => {
            if (code in sling.hookSpecs) {
                return {
                    text: sling.hookSpecs[code]["name"],
                    value: code,
                };
            }
        });
    }

    clickExportPdf() {
        const url = "https://www.kondotec.co.jp/techinfo/sling/sling_pdf/pdf.php";
        //const url = "https://www.teraos.net/testserver/kondotec/products/sling/sling_pdf/pdf.php";
        //const url = "http://localhost/test.pdf";
        /*
        const href = location.href.split("#").shift();
        const url = href + "sling_pdf/pdf.php";
        */

        const option: AxiosRequestConfig = {
            responseType: "arraybuffer",
        };

        if (!this.sling) return;

        const params: { [key: string]: string | number | null } = {
            targetWeight: this.sling.targetWeight,
            targetNumber: this.sling.targetNumber,
            diameter: this.sling.diameter,
            wireLength1: this.sling.wireLength,
            kakaku: this.sling.kakaku,
            code: this.sling.code,
            ringLength: this.sling.ringLength,
            ringWidth: this.sling.ringWidth,
            ringPhi: this.sling.ringPhi,
            wireLength2: this.sling.wireLength,
            hookLength: this.sling.hookLength,
            wire: this.sling.wire,
            ring: this.sling.ringSpec ? this.sling.ringSpec.name : "",
            hook: this.sling.hookSpec ? this.sling.hookSpec.name : "",

            ringImage: this.sling.ringImageName,
            wireImage: this.sling.wireImageName,
            hookImage: this.sling.hookImageName,
        };

        const paramstrs: string[] = [];

        for (const key in params) {
            const value = encodeURI(params[key] ? String(params[key]) : "");
            const param = `${key}=${value}`;

            paramstrs.push(param);
        }

        const url2 = url + "?" + paramstrs.join("&");

        axios.get(url2, option).then((response) => {
            const fileName = "sling.pdf";
            const type = "application/pdf";

            if (window.navigator && window.navigator.msSaveBlob) {
                // for IE, Edge
                const blob = new Blob([response.data]);

                console.log(blob);
                console.log(fileName);

                window.navigator.msSaveBlob(blob, fileName);
            } else {
                // for chrome, firefox
                const blob = response.data;

                const url = URL.createObjectURL(new Blob([blob], { type: type }));
                const linkEl = document.createElement("a");
                linkEl.href = url;
                linkEl.setAttribute("download", fileName);
                document.body.appendChild(linkEl);
                linkEl.click();

                URL.revokeObjectURL(url);

                if (linkEl.parentNode) linkEl.parentNode.removeChild(linkEl);
            }
        });
    }

    wireOptionChanged() {
        if (this.sling && this.sling.wireCode && this.sling.wireCode >= "5") {
            this.sling.hookCode = "N00";
        }
    }
}
